import { api } from '@/core/http/apiClient';
import type { ClientChartTemplateApplied, ClientChartTemplateStatus } from '@/core/models/phase9.models';

export const clientChartTemplateService = {
  getStatus: (clientId: string) => api.get<ClientChartTemplateStatus>(`ClientChartTemplate/getStatus/${clientId}`),

  applyTemplate: (clientId: string) =>
    api.post<ClientChartTemplateApplied>(`ClientChartTemplate/applyTemplate/${clientId}`, {}),
};
